const STATUSES = {
  pending: ["Payment pending", "Your payment has not been confirmed yet."],
  paid: ["Preparing order", "Your payment is confirmed. The author is preparing your order."],
  processing: ["Preparing order", "The author is preparing your order."],
  sent: ["Sent", "Your ebook download link has been sent by email."],
  link_clicked: ["Link clicked", "Your ebook link was accessed, possibly by an email security scanner. This does not confirm a download or reading. Links expire 30 days after purchase."],
  shipped: ["Shipped", "Your order has been marked as shipped."],
  delivered: ["Delivered", "Your order has been marked as delivered."],
  cancelled: ["Cancelled", "This order was cancelled."],
  canceled: ["Cancelled", "This order was cancelled."],
  refunded: ["Refunded", "This order was refunded."],
  failed: ["Payment failed", "Payment for this order was unsuccessful."],
};

export function getOrderTracking(order) {
  const status = String(order.status || "").toLowerCase().trim();
  let [label, description] = STATUSES[status] || ["Status unavailable", "Refresh to check for an order update."];
  let trackingUrl = "";
  try {
    const raw = order.shippo?.trackingUrl;
    if (typeof raw !== 'string' || /[\\\s]/.test(raw)) throw new Error();
    const url = new URL(raw);
    if (url.protocol === "https:" && !url.username && !url.password) trackingUrl = url.href;
  } catch { /* Tracking numbers can be supplied without a carrier URL. */ }
  if (["paid", "processing"].includes(status) && (order.shippo?.trackingNumber || trackingUrl)) {
    label = "Tracking available";
    description = "Tracking details have been added. Shipment has not yet been confirmed; check the carrier for its latest update.";
  }
  return { status, label, description, trackingUrl,
    active: ["pending", "paid", "processing", "shipped"].includes(status) };
}
